<template>
  <div>
    <div
      style="margin-top:10px;display:flex;justify-content:space-between;align-items:center"
    >
      <h2>{{ title }}</h2>
      <button
        class="button-square"
        style="height:30px"
        v-if="editable"
        @click="addDeduction"
      >
        Add Deduction
      </button>
    </div>
    <table style="margin-top:10px;">
      <thead>
        <tr>
          <th scope="col">Date</th>
          <th scope="col">Type</th>
          <th scope="col">Payment Deduction</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(tableItem, idx) in list" :key="idx">
          <td>{{ formatDate(tableItem.date) }}</td>
          <td>
            <div class="table-value-group">
              <div v-if="!tableItem.isEditing">{{ tableItem.t }}</div>
              <template v-if="tableItem.isEditing && editable">
                <select
                  class="select"
                  v-model="list[idx].deduction_type"
                  v-if="tableItem.tag !== 'timeoff'"
                >
                  <option :value="null" disabled="true">Select Type...</option>
                  <option
                    v-for="(option, optionIdx) in timeoffs"
                    :key="optionIdx"
                    >{{ option }}</option
                  >
                </select>
              </template>
              <i
                v-if="editable"
                class="fas fa-edit green-col pointer"
                @click="tableItem.isEditing = !tableItem.isEditing"
              ></i>
            </div>
          </td>
          <td v-if="editable && tableItem.isEditing">
            <div class="table-value-group">
              <input type="number" v-model.number="list[idx].deduction" />
              <div
                class="green-label pointer"
                @click="updateDeduction(tableItem)"
              >
                SAVE
              </div>
              <div
                class="red-label pointer"
                @click="deleteDeduction(tableItem)"
              >
                DELETE
              </div>
            </div>
          </td>
          <td v-else>{{ tableItem.deduction }}</td>
        </tr>

        <tr v-for="(it, idx) in newDeductions" :key="idx">
          <td>
            <div class="table-value-group">
              <select class="select" v-model="newDeductions[idx].date">
                <option :value="null" disabled="true">Select Date...</option>
                <option
                  v-for="(option, optionIdx) in dateOptions"
                  :key="optionIdx"
                  >{{ option }}</option
                >
              </select>
            </div>
          </td>
          <td>
            <div class="table-value-group">
              <select
                class="select"
                v-model="newDeductions[idx].deduction_type"
              >
                <option :value="null" disabled="true">Select Type...</option>
                <option
                  v-for="(option, optionIdx) in timeoffs"
                  :key="optionIdx"
                  >{{ option }}</option
                >
              </select>
            </div>
          </td>
          <td>
            <div class="table-value-group">
              <input
                type="number"
                v-model.number="newDeductions[idx].deduction"
              />
              <div
                class="green-label pointer"
                @click="submitDeduction(it)"
                v-if="it.date && it.deduction_type"
              >
                SAVE
              </div>
              <div
                class="red-label pointer"
                @click="$delete(newDeductions, idx)"
              >
                DELETE
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td>Total</td>
          <td>{{ total }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import { constants } from '../js/regents';
import dayjs from 'dayjs';
import { http } from '../digilib_web/core/digitify';

export default {
  computed: {
    editable() {
      return this.profile.role === 'admin';
    },
    total() {
      let rows = this.list;
      let total = 0;
      for (let i = 0; i < rows.length; ++i) {
        total += rows[i].deduction;
      }
      return `Rp. ${total.toLocaleString()}`;
    },
    timeoffs() {
      return [...constants.TIMEOFF_TYPE, 'Late'];
    },
    dateOptions() {
      let o = [];
      this.attendance.forEach(a => {
        o.push(a.date);
      });
      return o;
    }
  },
  props: {
    id: Number,
    profile: Object,
    list: Array,
    title: String,
    attendance: Array
  },
  data() {
    return {
      newDeductions: []
    };
  },
  methods: {
    formatDate(d) {
      return dayjs(d).format('ddd, DD MMM YYYY');
    },
    deleteDeduction(item) {
      if (item.id_deduction) {
        if (confirm('Are you sure to delete?')) {
          http
            .del(`employees/attendance/deductions/${item.id_deduction}`)
            .then(() => {
              this.$emit('shouldReload');
            });
        }
      }
    },
    updateDeduction(item) {
      if (item.id_deduction) {
        let payload = { amount: item.deduction, type: item.deduction_type };
        http
          .put(`employees/attendance/deductions/${item.id_deduction}`, payload)
          .then(() => {
            this.$emit('shouldReload');
          });
      }
    },
    addDeduction() {
      this.newDeductions.push({
        date: null,
        deduction_type: null,
        deduction: 0
      });
      //   this.$emit('update:model', this.editableModel)
    },
    submitDeduction(item) {
      let formattedDate = dayjs(item.date).format('YYYY-MM-DDTHH:mm:ssZ');
      let payload = {
        amount: item.deduction,
        type: item.deduction_type,
        id_employee: this.id,
        date: formattedDate
      };
      console.log(payload);
      http.post('employees/attendance/deductions', payload).then(json => {
        console.log(json);
        this.$emit('shouldReload');
      });
    }
  }
};
</script>
